export const Logo = ({ size = 44 }) => (
    <svg
        width={size}
        height={size}
        viewBox="0 0 64 64"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        data-testid="g1-logo"
    >
        <polygon
            points="32,5 51.1,13 59,32 51.1,51 32,59 12.9,51 5,32 12.9,13"
            fill="none"
            stroke="#D4AF37"
            strokeWidth="2.4"
        />
        <polygon
            points="32,10 47.5,16.5 54,32 47.5,47.5 32,54 16.5,47.5 10,32 16.5,16.5"
            fill="none"
            stroke="#D4AF37"
            strokeWidth="0.8"
            opacity="0.5"
        />
        <text
            x="32"
            y="41.5"
            fontFamily="Georgia, 'Times New Roman', serif"
            fontSize="22"
            fontWeight="600"
            fill="#E6C687"
            textAnchor="middle"
            letterSpacing="1"
        >
            G1
        </text>
    </svg>
);
